import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
// import { Row, Col } from 'react-bootstrap';
import Committeeleft from './Committeeleft';
import { Container, Row,Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
import { Table } from 'react-bootstrap';

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title='Home' subtitle="Senior Purchase Committee" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">

                        <Row>

                        <Col md={3} className='c-left custom-padding-color mb-4'>
                        <Committeeleft></Committeeleft>
                        </Col>
                
                        <Col md={9} className='c-right'>

                            
                                <h3 className='c-headline mb-3'>Senior Purchase Committee</h3>
                                <p className='c-lineheight2dot5'>The Senior Purchase Committee is hereby re-constituted with the following composition with immediate effect for a period of two years or till further orders whichever earlier to oversee all the procurements in the Institute worth ₹ 25 Lakhs and above:  </p>


                                <Table bordered responsive className='mt-3'>
                                    <tbody>
                                        <tr>
                                            <th>Sr. No</th>
                                            <th>Name</th>
                                            <th>Designation</th>
                                            <th>Role</th>
                                        </tr>
                                        <tr>
                                            <td>1.</td>
                                            <td>Prof. Venkata Ramana Badarla</td>
                                            <td>Professor & Dean - Administration & Finance</td>
                                            <td>Chairperson</td>
                                        </tr>
                                        <tr>
                                            <td>2.</td>
                                            <td>Prof. A Murali Krishna</td>
                                            <td>Professor & Dean - Planning & Infrastructure</td>
                                            <td>Alternative Chairperson / Member</td>
                                        </tr>
                                        <tr>
                                            <td>3.</td>
                                            <td>Brig. (Dr.) KP Krishna Kumar (Retd.)</td>
                                            <td>Registrar</td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>4.</td>
                                            <td>Prof. E Anil Kumar </td>
                                            <td>Professor & Dean - Sponsored Research & Consultancy</td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>5.</td>
                                            <td>Dr. KP Naveen</td>
                                            <td>Associate Professor & Head - Department of Electrical Engineering</td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>6.</td>
                                            <td>Dr. Rudra Sekhar Manna</td>
                                            <td>Associate Professor & Head - Department of Physics</td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>7.</td>
                                            <td>Prof. Gouriprasanna Roy</td>
                                            <td>Professor - Department of Chemistry</td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>8.</td>
                                            <td>Mr. Arun Kalyan Kuppannagari</td>
                                            <td>Assistant Registrar - Finance & Accounts</td>
                                            <td>Member</td>
                                        </tr>
                                        <tr>
                                            <td>9.</td>
                                            <td>Mr. Madhu N</td>
                                            <td>Assistant Registrar - Purchase</td>
                                            <td>Member Secretary</td>
                                        </tr>
                                        

                                        
                                    </tbody>

                                </Table>

                                </Col>

                           
                        </Row>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Main;